import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { AccountInfoStateType } from '@central-products/interface-account-info';
import { publish } from '@wh/message-bus';

import { Logo } from './logo/Logo';
import { ActionArea } from './actionArea/ActionArea';
import { hamburgerClicked, useDepositLinkVisible, useDepositVisible, useLoginVisible, useMessageBusSubscribe, useRegistrationVisible, useRequestToFlowStart, useSessionState } from './messagebus'
import './Header.scss';
import { ProductMenu } from './productMenu/ProductMenu';
import { useHeaderScrollOffset } from './useHeaderScrollOffset';
import { Hamburger } from './hamburger/Hamburger';
import { SecondaryPanel } from './subnav/SecondaryPanel';
import { depositWorkflow } from './deposit/depositWorkflow';
import { NavigationOverlay } from './navigationOverlay/NavigationOverlay';

export const Header = ({
  config,
  content,
  buildDeviceType,
  buildVertical,
  subNavStart,
  subNavEnd,
}) => {

  const [logoVariant, setLogoVariant] = useState('');
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [displayDepositLink, setDisplayDepositLink] = useState(false);
  const ACCOUNT_INFO_STATE_CHANGED_EVENT = 'wh.common.event.account.info.state.changed'

  useSessionState();
  useRequestToFlowStart();

  useMessageBusSubscribe(ACCOUNT_INFO_STATE_CHANGED_EVENT, ({ state, countryCode }) => {
    if(state === AccountInfoStateType.ACCOUNT_INFO_EXISTS) {
      setDisplayDepositLink(countryCode === 'UK');
      if (countryCode === 'UK') {
        publish('wh.common.command.ui.header.language.menu.hide');
      } else {
        publish('wh.common.command.ui.header.language.menu.show');
      }
    } else {
      setDisplayDepositLink(false);
    }
  });

  useEffect(() => {
    const updateVariant = () => {
        setLogoVariant(window?.innerWidth > 390 ? 'desktop' : 'mobile');
    }

    updateVariant();
    window.addEventListener('resize', updateVariant);
    
    return () => {
      window.removeEventListener('resize', updateVariant);
    }

  }, []);

  useEffect(() => {
    depositWorkflow({ disableQuickDeposit: !window?.kraken?.quickDepositEnabled });
  }, []);

  const depositLinkButtonVisible = useDepositLinkVisible(false) && displayDepositLink;
  const loginButtonVisible = useLoginVisible(false);
  const registrationButtonVisible = useRegistrationVisible(false);
  const depositButtonVisible = useDepositVisible(false);

  const buttonVisibility = (buildVertical === 'compliance-pages' || buildVertical === 'responsible-gaming') ? {
    depositLinkButtonVisible: false,
    loginButtonVisible: false,
    registrationButtonVisible: false,
    depositButtonVisible: false
  } : {
    depositLinkButtonVisible,
    loginButtonVisible,
    registrationButtonVisible,
    depositButtonVisible
  };

  useMessageBusSubscribe('sidebarNavigation.open', () => { setHamburgerOpen(true); })
  useMessageBusSubscribe('sidebarNavigation.close', () => { setHamburgerOpen(false); })

  const hamburgerClickHandler = () => {
    if (buildVertical.startsWith('sportsbook')) {
      publish('search.close');
      if (hamburgerOpen) {
        publish('sidebarNavigation.close');
      } else {
        publish('sidebarNavigation.open');
      }
    }
    hamburgerClicked();
  };

  useHeaderScrollOffset();

  const redirectToProduct = buildVertical !== 'gaming';

  const showHamburger = buildVertical.startsWith('sportsbook') || buildVertical === 'responsible-gaming';
  const showSubNav = subNavStart || subNavEnd;
  const showProductMenu = config.productMenuItems.length > 0;

  useEffect(() => {
    document.documentElement.style.setProperty('--header-subnav-base-height', showSubNav ? '36px' : '0px');
  }, [showSubNav]);

  useEffect(() => {
    document.documentElement.style.setProperty('--header-base-bottom-height', showProductMenu ? '36px' : '0px');
  }, [showProductMenu]);

  return <div data-reactroot className='sb-header-redesign'>
    <NavigationOverlay />
    <div data-test-id="pre-integrated-header" className="sb-pre-integrated-header">
      <div className={cx('sb-header', {
        'sb-header-shifted': hamburgerOpen,
        'sb-header-no-bottom-product-menu': (buildVertical === 'gaming' && buildDeviceType === 'mobile')
      })}>
        <div className='sb-header-grid'>
          <div className='sb-header-top-left'>
            {showHamburger && <Hamburger isOpen={hamburgerOpen} onClick={hamburgerClickHandler} />}
            <div className="sb-header-logo">
              <Logo variant={logoVariant} url={content?.['logo-href']} />
            </div>
          </div>

          <div className='sb-header-top-middle-filler'></div>
          {showProductMenu && (
          <div className="sb-header-nav">
            <div className="sb-header-nav-internal">
              <ProductMenu items={config.productMenuItems} redirectToProduct={redirectToProduct} />
            </div>
          </div>
          )}
          <div className="sb-action-area">
            <ActionArea content={content?.header} buildVertical={buildVertical} buttonVisibility={buttonVisibility} />
          </div>
        </div>
        {showSubNav &&
            <div className='sb-header-sub-nav'>
              <SecondaryPanel>
                {subNavStart}
                {subNavEnd}
              </SecondaryPanel>
            </div>
          }
      </div>
    </div>
  </div>;
};
